var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":_vm.type,"size":_vm.size,"loading":_vm.loading,"icon":"fas fa-wrench"},on:{"click":_vm.agreeNegotiation}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }